import { appInitializerFactory, BundledTranslateLoader } from "./app/app.module";
import { AppComponent } from "./app/app.component";
import { ENVIRONMENT } from "./environments/environment";
import { ServiceWorkerModule } from "@angular/service-worker";
import { NgxResizeObserverModule } from "ngx-resize-observer";
import { TableModule } from "./app/modules/table-module/table.module";
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { RoutesModule } from "./app/routes.module";
import { NotificationModule } from "./app/modules/notification-module/notification.module";
import { NavModule } from "./app/modules/nav-module/nav.module";
import { CardModule } from "./app/modules/card-module/card.module";
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { MaterialModule } from "./app/modules/material-module/material.module";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatRippleModule } from "@angular/material/core";
import { MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { MatSliderModule } from "@angular/material/slider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatIconModule } from "@angular/material/icon";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { GAS_THEME } from "./app/themes/gas-theme";
import { NORTEGAS_THEME } from "./app/themes/nortegas-theme";
import { WATER_THEME } from "./app/themes/water-theme";
import { DARK_THEME } from "./app/themes/dark-theme";
import { DEFAULT_THEME } from "./app/themes/default-theme";
import { HIGH_CONTRAST_THEME } from "./app/themes/high-contrast-theme";
import { ThemeModule } from "./app/themes/theme.module";
import { CustomReuseStrategy } from "./app/reuse-strategy";
import { RouteReuseStrategy } from "@angular/router";
import { MAT_CHECKBOX_DEFAULT_OPTIONS, MatCheckboxModule } from "@angular/material/checkbox";
import { MAT_RADIO_DEFAULT_OPTIONS, MatRadioModule } from "@angular/material/radio";
import { HttpRequestInterceptorService } from "./app/services/shared/HttpRequestServices/HttpRequestInterceptorService.service";
import {
  HTTP_INTERCEPTORS,
  withInterceptorsFromDi,
  provideHttpClient,
  HttpClient,
  withXhr
} from "@angular/common/http";
import { OVERLAY_DEFAULT_CONFIG } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { TranslateService, TranslateModule, TranslateLoader } from "@ngx-translate/core";
import {
  Injector,
  LOCALE_ID,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection
} from "@angular/core";
import { BnNgIdleService } from "bn-ng-idle";

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      ThemeModule.forRoot({
        themes: [
          DEFAULT_THEME,
          DARK_THEME,
          WATER_THEME,
          NORTEGAS_THEME,
          GAS_THEME,
          HIGH_CONTRAST_THEME
        ],
        active: "default"
      }),
      // @angular
      BrowserModule,
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      // @angular-material
      MatIconModule,
      MatSelectModule,
      MatFormFieldModule,
      MatSliderModule,
      MatInputModule,
      MatButtonModule,
      MatMenuModule,
      MatCheckboxModule,
      MatRadioModule,
      MatRippleModule,
      MatSlideToggleModule,
      MaterialModule,
      ScrollingModule,
      NgxSliderModule,
      // Cards
      CardModule,
      // Nav
      NavModule,
      // Notification
      NotificationModule,
      // Routes
      RoutesModule,
      // Selectors
      NgxDaterangepickerMd.forRoot({
        format: "DD/MM/YYYY",
        direction: "ltr",
        weekLabel: "W",
        separator: " - ",
        clearLabel: "",
        firstDay: 1
      }),
      // Spinner
      NgxSpinnerModule,
      // Table
      TableModule,
      // Translator
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: BundledTranslateLoader
        },
        defaultLanguage: "es"
      }),
      // Resize
      NgxResizeObserverModule,
      // Service Worker
      ServiceWorkerModule.register("ngsw-worker.js", {
        enabled: ENVIRONMENT.production,
        // enabled: true,
        // Register the ServiceWorker as soon as the application is stable
        // or after 30 seconds (whichever comes first).
        registrationStrategy: "registerWhenStable:30000"
      })
    ),
    BnNgIdleService,
    provideAppInitializer(() => {
      const initializerFn = appInitializerFactory(inject(TranslateService), inject(Injector));
      return initializerFn();
    }),
    { provide: LOCALE_ID, useValue: "es-ES" },
    { provide: LOCALE_ID, useValue: "en-EN" },
    { provide: LOCALE_ID, useValue: "it-IT" },
    { provide: LOCALE_ID, useValue: "es-CA" },
    { provide: LOCALE_ID, useValue: "fr-FR" },
    { provide: LOCALE_ID, useValue: "el-GR" },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptorService,
      multi: true
    },
    {
      provide: MAT_RADIO_DEFAULT_OPTIONS,
      useValue: { color: "primary" }
    },
    {
      provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
      useValue: { color: "primary" }
    },
    { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    provideHttpClient(withXhr(), withInterceptorsFromDi())
  ]
});

document.documentElement.setAttribute("lang", navigator.language);
